<template>
  <div class="profile-container">
    here will be newsletter stuff
    <span>Newsletter: {{ user.newsletter }}</span>
  </div>
</template>

<script>
export default {
  name: "profile-newsletter",
  props: { user: Object }
};
</script>

<style scoped lang="scss">
@import "~@/styles/global.scss";
</style>
